import zhCN from "vant/lib/locale/lang/zh-CN";

export default {
  ...zhCN,
  message: {
    login: '欢迎登录',
    lang:{
      zh: '中文',
      en: '英文'
    },
  },
  invitation_login: "邀请码登录",
  mobile_verification: "手机验证",
  email_verification: "邮箱验证",
  getInto: '即刻进入',
  register: '报名注册',
  register1: '报名已结束',
  submit: '提交',
  mailbox: '邮箱', 
  password: '密码',
  code: '验证码',
  register2: '注册账号',
  forgotPas: '忘记密码',
  setPas: '设置新密码',
  codeTxt: '看不清？换一张',
  newPasword: '新密码',
  newPasword1: '再次输入新密码',
  briefInfo: '会议简介',
  distribution: '会场分布',
  agenda: '会议议程',
  prevent: '疫情防控',
  promotionalVideo: '宣传片',
  promise: '健康承诺书',
  checkLocation: '核酸检测地',
  personalInfo: '个人中心',
  loginRegister: '登录注册',
  website: '官方网站',
  video: '视频集锦',
  album: '精彩相册',
  partner: '合作伙伴',
  media: '合作媒体',
  read: '我已阅读',
  gotIt: '我知道了',
  reg: '注册',
  help: '如需帮助请联系会议工作人员：010-xxxxxx',
  obtain_code: '获取验证码',
  yes_str: '是',
  no_str: '否',
  // 页面标题
  pageTitle: {
    China: '读懂中国',
    login: '登录',
    distribution: '会场分布',
    confirm: '确认参会',
    information: '完善信息',
    signUp: '报名参会',
    prevent: '疫情防控',
    promotionalVideo: '宣传片',
    promise: '健康承诺书',
    personalInfo: '个人中心'
  },
  input: {
    accountIncorrect: '账号格式不正确',
    emailTip: '邮箱不能为空',
    invitationTip: '邀请码不能为空',
    phoneTip: '手机号不能为空',
    pasTip: '密码不能为空',
    locationTip: '请选择归属地',
    notSame: '两次密码不一致',
    codeTip: '验证码不能为空',
  },
  // 参会须知
  noticeDia: {
    title: '参会须知',
    article1: '1.为确保嘉宾充分享受大会的权益，我们需要确认您的嘉宾身份。请您阅读以下要求，并提交您的资料。',
    article2: '2.信息会根据历史参会记录进行反显，需要您核实身份信息，信息有误可进行修改或联系工作人员；信息无误需进行参会确认。',
    article3_1: '3.会议举办时间：',
    article3_2: '2022年12月1日至2022年12月5日',
    article4: '4.其他说明规则文案内容其他说明规则文案内容其他说明规则文案内容其他说明规则文案内容其他说明规则文案内容。',
    article5: '大会联系电话：010-xxxxxxx'
  },
  photoDia: {
    title: '证件照（用于制作参会证件）',
    article1: '1.近期正面免冠彩色照片，白色背景，头部占照片面积一半以上。',
    article2: '2.尺寸：建议尺寸390*567，分辨率300像素/英寸。',
    article3: '3.格式：jpg、jpeg、png格式',
    article4: '4.大小：100K-5M',
  },
  resumePhotoDia: {
    title: '简历照',
    article1: '1.近期单人竖版彩色照片。',
    article2: '2.尺寸：建议尺寸1000*1500，分辨率300像素/英寸。',
    article3: '3.格式：jpg、jpeg、png格式',
    article4: '4.大小：100K-5M',
  },
  statementDia: {
    title: '请在此处上传您的会议发言稿（如有）',
    article1: '1.格式：doc、docx、ppt、pptx、pdf、zip、rar、7z格式',
    article2: '2.大小：50MB以内'
  },
  mediaDia: {
    title: '媒体参会须知',
    article1: '1.为确保媒体记者充分享受大会的权益，我们需要确认您的媒体身份。请您阅读以下要求，并提交您的资料。',
    article2: '2.在往届大会中通过认证，在新一届大会中不能直接获取您的参会资格，您需要重新报名。',
    article3_1: '3.需提交认证资料',
    article3_2: '平面媒体/新闻通讯社、广播电视新闻媒体、网络媒体，请提供：名片或记者证。',
    article3_3: '自媒体人、KOL，请提供：自媒体数据截图。行业分析师，请提供：名片',
    article4: '4.提交信息后即报名成功，工作人员将审核您的信息，通过审核会向您发送确认信息，您可在大会期间凭确认邮件或注册手机号签到领取胸卡。',
  },
  uploadDia: {
    title: '上传附件',
    article1: '1.记者证/其他证明正面照片',
    article2: '2.格式：jpg、jpeg、png格式',
    article3: '3.大小：100K-5M'
  },
  confirmDia: {
    title: '温馨提示',
    message: '信息提交后仅在规定时间内可修改，请您仔细核对再提交。',
    confirm: '确认提交',
    cancel: '返回修改'
  },
  // 步骤条
  steps: {
    person: '基本信息',
    contact: '联系信息',
    active: '意向参会信息',
    statement: '发言稿收集',
    trip: '意向抵离信息',
    interview: '采访意向',
    arriveLeave: '意向交通信息'
  },
  // 表单
  form: {
    title: {
      basic: '基础信息',
      post: '职务信息',
      resume: '简历信息',
      other: '其他信息',
      person: '个人联系信息',
      work: '工作联系信息',
      urgent: '紧急联系信息',
      forum: '专题论坛',
      workshop: '专题研讨会',
      arrive: '抵穗信息',
      leave: '离穗信息',
      accommodation: '住宿信息',
      statement: '大会发言稿'
    },
    label: {
      enter: '请输入',
      choice: '请选择',
      surnameCh: '姓（中）',
      nameCh: '名（中）',
      nameCh_I: '姓名（中）',
      surnameEn: '姓（英）',
      nameEn: '名（英）',
      nameEn_I: '姓名（英）',
      fullName: '姓名',
      photo: '证件照',
      resumePhoto: '简历照',
      birth: '出生日期',
      gender: '性别',
      nationality: '国籍',
      nation: '民族',
      country: '代表国家',
      diet: '饮食禁忌',
      documentType: '证件类型',
      documentNum: '证件号码',
      documentVal: '证件有效期',
      permanent: '长期',
      validUntil: '有效期',
      companyCh: '单位及职务（中）',
      companyEn: '单位及职务（英）',
      researchField: '研究领域（可多选）',
      guangzhouLevel: '行政级别',
      joinType: '参会方式',
      company: '单位',
      postCh: '职务（中）',
      postEn: '职务（英）',
      post: '职务',
      resumeCh: '主要工作经历及任职',
      resumeChPlaceholder: '现任xxxx、xxxx、xxxx，兼任xxxx、xxxx、xxxx。曾任xxxx、xxxx、xxxx。研究领域：xxxx、xxxx、xxxx。（100字以内）',
      resumeEn: '英文主要工作经历及任职',
      resumeEnPlaceholder: '现任xxxx、xxxx、xxxx，兼任xxxx、xxxx、xxxx。曾任xxxx、xxxx、xxxx。研究领域：xxxx、xxxx、xxxx。',
      vaccinated: '是否接种疫苗',
      vaccinePhoto: '请上传新冠疫苗接种证明',
      uploadPhoto: '上传照片',
      next: '下一步',
      previous: '上一步',
      mail: '邮箱',
      initialPas: '初始密码为123456',
      phone: '手机号码',
      region: '所在地区',
      address: '详细地址',
      contact: {
        work: '工作联系人',
        urgent: '紧急联系人'
      },
      pichUp: '接机/接站服务',
      delivery: '送机/送站服务',
      travel: '出行方式',
      lk_travel: '出行方式',
      number: '航班/车次',
      seat: '舱位/座位号',
      depTime: '出发时间',
      depAddress: '出发地',
      arrTime: '到达时间',
      destination: '目的地',
      accommodation: '住宿方式',
      submitAndConfirm: '提交并确认参会',
      submit: '提交',
      havePress: '是否有记者证',
      pressCard: '记者证',
      pressID: '记者证号码',
      otherInfo: '证明资料',
      uploadAtta: '记者证照片或单位证明',
      deviceInfo: '媒体设备信息',
      interview: {
        object: '采访对象',
        date: '意向日期',
        time: '意向时间',
        theme: '采访主题',
        problem: '采访问题'
      },
      briefInfo: '工作内容',
      briefInfoEnter: '请输入你所在的分论坛/活动，如【平1中国式现代化与人类命运共同体】，或【读懂中国电视片宣介活动】，并简要描写工作内容。',
      Participants: '参会身份',
      explain: '未接种说明',
      WeChat: '微信',
      needInvitationLetter: '是否需要提供签证邀请函'
    }
  },
  upload_photo: {
    title: '上传照片',
    avatar_str: '证件照（用于制作参会证件）',
    avatar_tip1: '1.近期正面免冠彩色照片，白色背景，头部占照片面积一半以上。',
    avatar_tip2: '2.尺寸：建议尺寸390*567，分辨率300像素/英寸。',
    avatar_tip3: '3.格式：jpg、jpeg、png格式。',
    avatar_tip4: '4.大小：100KB-5MB',
    photo_str: '简历照',
    photo_tip1: '1.近期单人竖版彩色照片。',
    passport_str: '护照首页',
    passport_tip1: '1.护照个人资料页正面照片，要求照片文字内容清晰。',
    passport_tip2: '2.尺寸：建议尺寸390*290。',
    passport_tip3: '3.大小：100KB-5MB',
  },
  infoTip: '以下为个人参会意向，最终参会安排以组委会通知为准。',
  infoTipGti: '请选择确认出席的活动。',
  interviewInfoTip: 'Our staff will confirm with you and arrange your interviews according to your interview preference.',
  date: {
    one: '12月1日',
    two: '12月2日',
    three: '12月3日',
    four: '12月4日',
    five: '12月5日',
    six: '12月6日'
  },
  special: {
    forum1: '专题论坛一：新时代、新青年、新担当',
    forum2: '专题论坛二：中国特色志愿服务',
    forum3: '专题论坛三：读懂中国电视片对话会',
    forum4: '专题论坛四：教育与健康中国',
    forum5: '专题论坛五：新视野下文化遗产的可持续发展',
    workshop1: '研讨会一：中国现代化新征程与全球合作新机遇',
    workshop2: '读懂广州专题研讨会二：科技创新与先进制造',
    workshop3: '专题研讨会三：枢纽经济',
    workshop4: '粤港澳大湾区国际传播战略合作签约仪式',
    workshop5: '研讨会三：国际抗疫合作与人类卫生健康共同体',
    workshop6: '研讨会八：文明交流互鉴与讲好中国故事',
    other1: '“读懂中国”丛书（第二辑）发布会',
    other2: '“读懂中国”国际传播合作签约启动仪式里“读懂中国”国际传播合作签约启',
    other: '自助午餐'
  },
  forum: '专题论坛',
  workshop: '专题研讨会',
  other: '其他日程',
  dinner: '用餐安排',
  parallel: '平行研讨会',
  floors: {
    one: '1层',
    two: '2层',
    three: '3层',
    four: '4层',
    five: '5层',
    six: '6层',
    seven: '7层'
  },
  leader: '领导人',
  survey: '大会概况',
  host: '主办单位：国创会',
  CoOrganizer: '协办单位：协办单位1名称、协办单位2名称',
  time: '大会时间：', // 2021-12-1  ~  2021-12-5
  address: '大会地点：', // 广州市珠海区滨江东路498号（近海印大桥）
  partnerList: {
    one: '中国人民外交学会',
    two: '中共中央党校',
    three: '中国科学院',
    four: '中国外文出版发行事业局'
  },
  // 健康承诺书
  health: {
    title: '健康承诺书',
    text: '本人郑重承诺如下：',
    text1: '一、本人目前无发热、咳嗽、乏力等符合新冠肺炎的症状。',
    text2: '二、本人及其共同生活的家庭成员没有被诊断为新冠肺炎确诊病例或疑似病例。',
    text3_1: '三、本人近期未接触过疑似、确诊、无症状感染新冠肺炎者，并',
    text3_2: '已经过14天隔离期',
    text3_3: '，且在隔离期内无符合新冠肺炎的症状。',
    text4: '四、本人生活的小区、单元楼、村组或工作的单位14天内没有发生过确诊病例。',
    text5: '五、本人将严格按照新冠肺炎防疫要求，配合社区(村)、小区物业人员开展的防疫工作，如实申报个人健康状况。做好个人防护,养成良好生活及卫生习惯，积极参与社区(村)安排的志愿者活动。',
    text6: '六、本人对以上提供的健康信息的真实性负责，如因信息不实引起疫情传播和扩散，愿承担由此带来的全部法律责任。',
    check1: '无心脏病史',
    check2: '无其他病史',
    Promisor: '承诺人：', // 张伟
    PromisorPhone: '手机号：',
    PromisorIdNumber: '身份证号：',
    '7days': '7天内途径地：',
    button1: '我已阅读，确认承诺',
    button2: '已承诺',
  },
  routeTitle: {
    understandChina: '读懂中国',
    login: '登录',
    health: '健康承诺书',
    promotionalVideo: '宣传片',
    improve: '完善信息',
    floor: '会场分布',
    agenda: '会议议程',
    personal: '个人中心',
    arrangeSearch: '排座搜索',
    video: '视频集锦',
    notify: '消息通知',
    setting: '设置',
    changePassword: '修改密码',
    cooperation: '合作伙伴',
    confirm: '确认参会',
    register: '报名参会'
  },
  personal: {
    tab0: '注册信息',
    tab1: '活动信息',
    tab2: '交通信息',
    tab3: '酒店信息',
    tab4: '用餐信息',
    tab5: '联系信息',
    tab6: '大会信息',
    item2: {
      go: '去程',
      back: '返程'
    },
    Registration: {
      information: '注册信息',
      edit: '修改',
      view: '查看',
      filling: '填报'
    },
    Accommodation: {
      checkin: '入住',
      leave: '退房'
    }
  },
}